import { ProductTypeSerializer } from './ProductTypeSerializer';

class SubMenuSerializer {
  static deSerialize(data) {
    return {
      name: data.SFANombre,
      id: String(data.SFAID),
      index: data.SFaOrdenWeb,
      image: data.SFaImagen,
      nameColor: data.SFATextoColor,
      productTypes: (data.MenuGrupoCaracteristicas || []).map(ProductTypeSerializer.deSerialize),
    };
  }
}

export { SubMenuSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/SubMenuSerializer.js